import { useCallback, useEffect, useMemo, useState } from 'react';
import getDcList from '../../api/cars/getDcList';
import Select from '../Select/Select';

const formatOption = (item) => ({ value: item.id, label: item.name });

// ÐÑÐ»ÑÑÐ¸ÑÐµÐ»ÐµÐºÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ñ ÑÐµÐ½ÑÑÐ¾Ð². ÐÐ¿ÑÐ¸Ð¸ Ð³ÑÑÐ·ÑÑÑÑ Ð¸Ð· GET /crm/cars/getDcList.
// ÐÐ¾Ð¶Ð½Ð¾ ÑÑÐ·Ð¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ cityId / mark / used (used=true â ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ¡Ð, ÑÐ¾ÑÐºÐ¸ ÐÐ£-Ð°Ð²ÑÐ¾). ÐÐµÐ¹Ð±Ð»Ñ Ð´Ð»Ñ Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹
// ÑÐµÐ·Ð¾Ð»Ð²ÑÑÑÑ Ð¸Ð· Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°, Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð² value Ð¿ÑÐ¸ÑÐ»Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ id.
const SelectDc = ({ handleSetSelect, handleSetState, style, cityId, mark, used, value, defaultValue, onChange, ...props }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(() => {
    if (isLoading || options.length > 0) return;
    setIsLoading(true);
    getDcList({ cityId, mark, used })
      .then((res) => {
        setOptions((res?.data || []).map(formatOption));
      })
      .finally(() => setIsLoading(false));
  }, [cityId, mark, used, isLoading, options.length]);

  // ÐÑÑÐ·Ð¸Ð¼ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÑÐ°Ð·Ñ, ÑÑÐ¾Ð±Ñ ÑÐµÐ·Ð¾Ð»Ð²Ð¸ÑÑ Ð»ÐµÐ¹Ð±Ð»Ñ Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÑ ÐÐ¦.
  useEffect(() => {
    load();
  }, [load]);

  // ÐÐ¾Ð´Ð¼ÐµÐ½ÑÐµÐ¼ Ð»ÐµÐ¹Ð±Ð»Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ Ð½Ð° Ð°ÐºÑÑÐ°Ð»ÑÐ½ÑÐµ Ð¸Ð· Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°.
  // ÐÐ´Ð¸Ð½Ð¾ÑÐ½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ (Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â ÑÐ¾Ð²Ð½Ð¾ Ð¾Ð´Ð¸Ð½ ÐÐ¡Ð) Ð¸
  // Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ðµ defaultValue ÑÐ°Ð½ÑÑÐµ Ð½Ðµ ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ð»Ð¸ÑÑ: Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¼Ð°ÑÐ¸Ð½Ñ
  // Ð²Ð¼ÐµÑÑÐ¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐÐ¦ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»ÑÑ ÐµÐ³Ð¾ Ð½Ð¾Ð¼ÐµÑ, Â«76Â».
  const relabel = useCallback(
    (val) => {
      const one = (item) => options.find((o) => o.value === item?.value) || item;
      if (val == null) return val;
      return Array.isArray(val) ? val.map(one) : one(val);
    },
    [options]
  );
  // react-select ÑÐ¸ÑÐ°ÐµÑ defaultValue Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¿ÑÐ¸ Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸, Ð° ÑÐ¿Ð¸ÑÐ¾Ðº ÐÐ¦
  // Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ð¿Ð¾Ð·Ð¶Ðµ â Ð¿Ð¾Ð´Ð¼ÐµÐ½ÑÐ½Ð½ÑÐ¹ Ð»ÐµÐ¹Ð±Ð» Ð´Ð¾ Ð½ÐµÐ³Ð¾ Ð½Ðµ Ð´Ð¾ÐµÐ·Ð¶Ð°ÐµÑ. ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð²
  // Ð½ÐµÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼Ð¾Ð¼ ÑÐµÐ¶Ð¸Ð¼Ðµ Ð´ÐµÑÐ¶Ð¸Ð¼ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¸ Ð¸ Ð¾ÑÐ´Ð°ÑÐ¼ ÐµÐ³Ð¾ ÐºÐ°Ðº value.
  const [inner, setInner] = useState(defaultValue ?? null);
  useEffect(() => {
    setInner(defaultValue ?? null);
  }, [defaultValue]);
  const resolvedValue = useMemo(
    () => relabel(value !== undefined ? value : inner),
    [value, inner, relabel]
  );

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      value={resolvedValue}
      onChange={(val) => {
        setInner(val);
        if (onChange) onChange(val);
      }}
      isMulti
      isSearchable
      isLoading={isLoading}
      onFocus={load}
      title={'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      style={style}
      {...props}
    />
  );
};

export default SelectDc;
